interface AuthAlertProps {
  children: string;
}

/** A failure that came back from the server, above the form it belongs to. */
export const AuthAlert = ({ children }: AuthAlertProps) => (
  <p role="alert" className="rounded-lg bg-auth-error/10 px-3 py-2 text-sm text-auth-error">
    {children}
  </p>
);
